import { render, staticRenderFns } from "./layout.vue?vue&type=template&id=bdd7b4a4&scoped=true"
import script from "./layout.vue?vue&type=script&lang=ts"
export * from "./layout.vue?vue&type=script&lang=ts"
import style0 from "./layout.vue?vue&type=style&index=0&id=bdd7b4a4&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bdd7b4a4",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/usr/src/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bdd7b4a4')) {
      api.createRecord('bdd7b4a4', component.options)
    } else {
      api.reload('bdd7b4a4', component.options)
    }
    module.hot.accept("./layout.vue?vue&type=template&id=bdd7b4a4&scoped=true", function () {
      api.rerender('bdd7b4a4', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/layout.vue"
export default component.exports